import api from './api';

const jobService = {
  // Get all jobs with filters
  getJobs: async (params = {}) => {
    const response = await api.get('/jobs', { params });
    return response;
  },

  // Get single job by ID
  getJobById: async (id) => {
    const response = await api.get(`/jobs/${id}`);
    return response;
  },

  // Get featured jobs
  getFeaturedJobs: async (limit = 6) => {
    const response = await api.get('/jobs/featured', { params: { limit } });
    return response;
  },

  // Get jobs by company
  getJobsByCompany: async (companyId, params = {}) => {
    const response = await api.get(`/jobs/company/${companyId}`, { params });
    return response;
  },

  // Get similar jobs
  getSimilarJobs: async (jobId) => {
    const response = await api.get(`/jobs/${jobId}/similar`);
    return response;
  },

  // Create new job (Employer/Consultant)
  createJob: async (jobData) => {
    const response = await api.post('/jobs', jobData);
    return response;
  },

  // Update job
  updateJob: async (id, jobData) => {
    const response = await api.put(`/jobs/${id}`, jobData);
    return response;
  },

  // Delete job
  deleteJob: async (id) => {
    const response = await api.delete(`/jobs/${id}`);
    return response;
  },

  // Get my jobs (posted by logged in user)
  getMyJobs: async (params = {}) => {
    const response = await api.get('/jobs/my/jobs', { params });
    return response;
  },

  // Get job statistics
  getJobStats: async () => {
    const response = await api.get('/jobs/my/stats');
    return response;
  },

  // Update job status
  updateJobStatus: async (id, status) => {
    const response = await api.patch(`/jobs/${id}/status`, { status });
    return response;
  },

  // Search jobs
  searchJobs: async (searchParams) => {
    const response = await api.get('/jobs', { params: searchParams });
    return response;
  },

  // Save a job
  saveJob: async (jobId, notes = '') => {
    const response = await api.post(`/saved-jobs/${jobId}/save`, { notes });
    return response;
  },

  // Unsave a job
  unsaveJob: async (jobId) => {
    const response = await api.delete(`/saved-jobs/${jobId}/save`);
    return response;
  },

  // Get saved jobs
  getSavedJobs: async (params = {}) => {
    const response = await api.get('/saved-jobs', { params });
    return response;
  },

  // Check if job is saved
  isJobSaved: async (jobId) => {
    const response = await api.get(`/saved-jobs/${jobId}/is-saved`);
    return response;
  },

  // Get saved jobs count
  getSavedJobsCount: async () => {
    const response = await api.get('/saved-jobs/count');
    return response;
  }
};

export default jobService;
